import axios from 'axios'
import store from '@/store'

export function noop() {}

// 下载模版
export async function downloadTemplate(url, title = '《批量分配模板》.xlsx') {
  const res = await axios({
    method: 'get',
    url,
    responseType: 'blob'
  })
  const blob = res?.data
  downloadFile(
    blob,
    title.indexOf('.xlsx') > -1 ? title : `${title}.xlsx`,
    'application/vnd.ms-excel'
  )
}

// 下载mp4
export async function downloadMp4(url, title = 'D.mp4') {
  store.dispatch('app/showLoading')
  const res = await axios({
    method: 'get',
    url,
    responseType: 'blob'
  })
  store.dispatch('app/hideLoading')
  const blob = res?.data
  downloadFile(blob, title, 'application/mp4')
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * 延时 用于async函数内
 * @returns {Promise}
 */
export const waitFor = (time = 1000) => {
  return new Promise((resolve) => {
    setTimeout(resolve, time)
  })
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach((v) => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * 用于下载blob流文件
 */
export function downloadFile(res, fileName, type) {
  // console.log('==========' + res)
  const blob = new Blob([res], { type: type })
  if ('download' in document.createElement('a')) {
    // 非IE下载
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = window.URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    window.URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName)
  }
}
// base64转blob
export function base64ToBlob(base64Data) {
  var byteString
  if (base64Data.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(base64Data.split(',')[1])
  } else {
    byteString = unescape(base64Data.split(',')[1])
    var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]
  }
  var ia = new Uint8Array(byteString.length)
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ia], { type: mimeString })
}

/**
 * @description: 金额三位加一个逗号
 * @param {*} num
 * @return {*}
 */
export function toThousandFilter(num) {
  return (+num || 0).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
}

// 只拷贝对象内存在的字段
export const mergeObjectsByExist = (...args) => {
  const baseObj = [args[0]]
  const objList = args.reverse().map((item) => item || {})
  const allKeysObj = baseObj.reduce((acc, cur) => ({ ...acc, ...cur }), {})
  return Object.keys(allKeysObj).reduce((acc, cur) => {
    const existObj = objList.find((el) => !!el[cur])
    acc[cur] = existObj ? existObj[cur] : baseObj[0][cur]
    return acc
  }, {})
}

// value 映射 babel
export const valueToBabel = (opts = [], key = '', none = '-') => {
  const map = opts.reduce((pre, item) => {
    if (item.value || item.value == 0) {
      pre[item.value] = item.label
    }
    return pre
  }, {})
  if (key instanceof Array) {
    let _txt = ''
    key.forEach((item) => {
      _txt += map[item] + '，'
    })

    _txt = _txt.substring(0, _txt.length - 1)
    return _txt || none
  } else {
    return map[key] || none
  }
}

export const getFileType = function(fileName) {
  // 后缀获取
  var suffix = ''
  // 获取类型结果
  var result = ''
  try {
    var flieArr = fileName.split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = false
    return result
  }
  // 图片格式
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
  // 进行图片匹配
  result = imglist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'image'
    return result
  }

  // 匹配txt
  var txtlist = ['txt']
  result = txtlist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'file'
    return result
  }

  // 匹配 excel
  var excelist = ['xls', 'xlsx']
  result = excelist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'file'
    return result
  }

  // 匹配 word
  var wordlist = ['doc', 'docx']
  result = wordlist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'file'
    return result
  }

  // 匹配 pdf
  var pdflist = ['pdf']
  result = pdflist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'file'
    return result
  }

  // 匹配 ppt
  var pptlist = ['ppt']
  result = pptlist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'file'
    return result
  }

  // 匹配 视频
  var videolist = ['mp4', 'm2v', 'mkv']
  result = videolist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'video'
    return result
  }

  // 匹配 音频
  var radiolist = ['mp3', 'wav', 'wmv']
  result = radiolist.some(function(item) {
    return item == suffix
  })
  if (result) {
    result = 'file'
    return result
  }
  // 其他 文件类型
  result = 'other'
  return result
}

export const encryptTel = (val) => {
  const tel = val.split('')
  tel.splice(3, 4, '****')

  return tel.join('')
}

export function loadScript(url, cb = () => {}, error = () => {}) {
  var script = document.createElement('script')
  script.async = true
  script.src = url
  var firstScript = document.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore(script, firstScript)

  // script 加载完毕后调用方法
  script.onload = script.onreadystatechange = function() {
    if (
      !this.readyState || // 这是FF的判断语句，因为ff下没有readyState这个值，IE的readyState肯定有值
      this.readyState == 'loaded' ||
      this.readyState == 'complete' // 这是IE的判断语句
    ) {
      cb && cb()
    }
  }

  script.onerror = function() {
    error && error()
  }
}

export async function asyncLoadScript(url) {
  return new Promise((resolve, reject) => {
    loadScript(url, resolve, reject)
  })
}

// 是否在当前路由下有权限
export function inPermission(action) {
  const currentView = store.state.tagsView.currentView
  const buttons = currentView?.meta?.buttons
  return buttons?.map((btn) => btn.name).includes(action)
}

/*用正则表达式实现html解码（反转义）*/
export function htmlDecodeByRegExp (str){  
  var temp = "";
  if(str.length == 0) return ""
  // temp = str.replace(/&amp;/g,"&");
  // temp = temp.replace(/&lt;/g,"<");
  // temp = temp.replace(/&gt;/g,">");
  temp = str.replace(/&nbsp;/g, ' ')
  // temp = temp.replace(/&#39;/g,"\'");
  // temp = temp.replace(/&quot;/g,"\"");
  return temp
}
